import React from 'react';
import PropTypes from 'prop-types';
import LabelLift from "../UI/LabelLift";
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift1R = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift1R"
			 className={getLiftClass(isOpen, activeLiftId === '1R', state)}
			 transform="translate(992.000000, 756.000000)"
		>
			<LiftLine x1="13.5" y1="15.5050737" x2="147.5" y2="291.505074" color={colors[0]}/>
			<LabelLift coords="135.000000, 278.005074" isOpen={isOpen}/>

			<circle fill={colors[1]} cx="13" cy="13" r="13"/>
			<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>

			<g strokeWidth="1" transform="translate(5.000000, 4.000000)"
				 fill={colors[2]} fontFamily="OpenSans-Bold, Open Sans" fontSize="12"
				 fontWeight="bold"
			>
				<text>
					<tspan x="4.8" y="13">1</tspan>
				</text>
			</g>

			<LabelLift coords="135.000000, 278.005074" isOpen={isOpen} state={state}/>

			<polygon
				fill={colors[2]}
				transform="translate(147.500000, 290.500000) scale(-1, 1) rotate(-248.000000) translate(-147.500000, -290.500000) "
				points="142 290.5 153 285 150.628513 290.5 153 296"
			/>

			<LiftLabelTypeSeat
				coords="53.000000, 111.000000"
				colors={getLiftStatusColors(state, isOpen)}
				isOpen={isOpen}
				seatCount="4"
			/>
		</g>
	);
};

Lift1R.propTypes = {
	isOpen: PropTypes.bool,
	activeLiftId: PropTypes.string
};

export default Lift1R;
